module.exports = __webpack_public_path__ + "static/media/tire-rugged.6ff925e6.svg";